<template>
    <div style="background: #FAFAFA;">
        <div class="container" style="padding-top: 0.5rem; padding-bottom: 3rem; height: 100vh;">

           

            <!-- Countdown Area starts -->
            <div class="" style="background-color: rgb(250, 250, 250);">
                <!-- ACTIVE COUNTDOWN -->
                <div v-if="showCountdown" class="countdown-container">
                    <h2 class="title">Challenge Starts Starts In:</h2>
                    <div class="timer">
                        <div class="time-block">
                            <span class="number">{{ countdown.days }}</span>
                            <span class="label">Days</span>
                        </div>
                        <div class="time-block">
                            <span class="number">{{ countdown.hours }}</span>
                            <span class="label">Hours</span>
                        </div>
                        <div class="time-block">
                            <span class="number">{{ countdown.minutes }}</span>
                            <span class="label">Mins</span>
                        </div>
                        <div class="time-block">
                            <span class="number">{{ countdown.seconds }}</span>
                            <span class="label">Secs</span>
                        </div>
                    </div>
                </div>

                <!-- EXPIRED / REPLACEMENT ELEMENT -->
                <!-- <div v-else class="expired-container">
                    <h2 class="title success">The challenge Has Started!</h2>
                    <p class="description">Enjoy the process, you are special.</p>
                </div> -->
            <!-- </div> -->
            <!-- Countdown Arear ends -->


                <div v-else>
                    <div v-if="loading">
                        <PageLoader></PageLoader>
                    </div>
                    <div v-else>
                        <div class="top-spot mt-5">
                            <h5 @click="goBack()"><span><i class="fa fa-chevron-left"></i></span> Kids Challenges</h5>
                            <!-- <button class="btn" @click="routeTo('superkid-register')">
                                Notification
                            </button> -->
                        </div>
                        <div class="name-tag" v-if="activeKid">
                            <h3>Hello, {{ activeKid.firstname }} {{ activeKid.lastname }}</h3>
                        </div>
                        <div v-if="slides.length == 0 && !loading">
                            <EmptyState :emptyData="emptyDataObject"></EmptyState>
                        </div>
                        <div class="carosel-section col-md-12 m-auto"  v-if="slides.length">
                            <div id="customCarousel" class="carousel slide" data-ride="carousel" data-wrap="false">
        
                            

                            <!-- Carousel Inner -->
                            <div class="carousel-inner">

                                <!-- Slide 1 -->
                                <div class="carousel-item" v-for="(slide, index) in slides"
                                :key="`slide-${index}`"
                                :class="{ active: index === 0 }">
                                    <img :src="slide.imageUrl"
                                        class="d-block w-100"
                                        alt="Slide 1">

                                    <!-- OVERLAY CONTENT -->
                                    <div class="overlay-content" v-if="slide">
                                        <h6>{{ slide.challenge_category.name }}</h6>
                                        <h3>{{slide.title}}</h3>
                                        <p>{{slide.details}}</p>
                                        <h4>{{slide.timeLeft}}</h4>
                                        <button class="btn" @click="routeTo(`/dashboard/view-challenge/${slide.id}/${activeKid.id}`)">View Challenge</button>
                                        
                                    </div>

                                    <div class="carousel-caption d-none d-md-block">
                                        <!-- <h5>First Slide Title</h5>
                                        <p>This is some description text for the first slide.</p> -->
                                    </div>
                                </div>

                                <!-- Slide 2 -->

                                <!-- Slide 3 -->
                                <!-- <div class="carousel-item">
                                    <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1772111385/Challenge_card_small_1_exf8wa.svg"
                                        class="d-block w-100"
                                        alt="Slide 3">

                                    <div class="carousel-caption d-none d-md-block">
                                        
                                    </div>
                                </div> -->

                            </div>

                            <!-- Indicators -->
                            <ol class="carousel-indicators">
                                <li
                                v-for="(slide, index) in slides"
                                :key="`indicator-${index}`"
                                :data-target="'#customCarousel'"
                                :data-slide-to="index"
                                :class="{ active: index === 0 }"
                                ></li>
                                <!-- @click="goToSlide(index)" -->

                                <!-- <li data-target="#customCarousel" data-slide-to="1"></li>
                                <li data-target="#customCarousel" data-slide-to="2"></li> -->
                            </ol>

                            <!-- Controls -->
                            <a class="carousel-control-prev" href="#customCarousel" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>

                            <a class="carousel-control-next" href="#customCarousel" role="button" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a>

                            <!-- <a class="carousel-control-prev" href="#" @click.prevent="prevSlide">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#" @click.prevent="nextSlide">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->

                            </div>
                        </div>

                        <div class="number_counter d-none">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="count-item">
                                                <h5>Current Votes</h5>
                                                <h2>1,2000</h2>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div  class="count-item">
                                                <h5>Leaderboard Rank</h5>
                                                <h2>1<span>st</span></h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="latest-achievement" v-if="slides.length">
                            <div class="middle-section">
                                <h6>Latest achievement.</h6>
                                <button class="btn" @click="routeTo('/dashboard/my-challenges')">My Challenges</button>
                            </div>
                            <div class="achievement_list">
                                <div class="achievement_item d-flex text-align-left" style="gap: 15px; " v-for="(item, index) in slides" :key="index">
                                    <span>
                                        <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1779271685/icons_v5jv1j.svg" alt="">
                                    </span>
                                    <div>
                                        <h5>{{ item.votes }} Votes</h5>
                                        <h4>Well done {{activeKid.firstname}}, your submission in <small style="font-weight: 800; ">{{item.challenge_category.name}}</small> category has {{ item.votes }} votes. </h4>
                                    </div>
                                    <hr></hr>
                                </div>
                            </div>
                        </div>
                        
                        <!-- <SubmissionComponent></SubmissionComponent> -->
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {  fetchSuperkidsParentsKids} from '../../utils';
import EmptyState from "../../components/EmptyState.vue";
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import SubmissionComponent from './SubmissionComponent.vue';
import moment from "moment";
import $ from "jquery";
export default {
    name: "KidDasboard",
    components: {
        PageLoader,
        EmptyState,
        SubmissionComponent
    },

    data() {
        return {
            loading: false,
            slides: [
                
            ],
            activeIndex: 0,
            mySuperKids: null,
            activeKid: null,
            emptyDataObject: {
                header: "No Challenge yet",
                option: "Kid does not have any challenge yet"
            },
            // startDate: new Date('2026-06-18T12:00:00'), 
            // endDate: new Date('2026-06-25T18:00:00'), 
            // currentTime: new Date(),  
            startDate: "", 
            endDate: "",  
            currentTime: "",
            timerInterval: null,
            timer: null,
            currentServerTime: null
        };
    },
    computed: {
        showCountdown() {
            return this.currentTime &&
            this.startDate > this.currentTime;
        },
        countdown() {
            // console.log("Current Server Time:", new Date(this.currentTime));
            if (!this.currentTime) {
                return {
                    days: "00",
                    hours: "00",
                    minutes: "00",
                    seconds: "00"
                };
            }

            const distance = this.startDate - this.currentTime;

            if (distance <= 0) {
                return {
                    days: "00",
                    hours: "00",
                    minutes: "00",
                    seconds: "00"
                };
            }

            const days = Math.floor(
                distance / (1000 * 60 * 60 * 24)
            );

            const hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) /
                (1000 * 60 * 60)
            );

            const minutes = Math.floor(
                (distance % (1000 * 60 * 60)) /
                (1000 * 60)
            );

            const seconds = Math.floor(
                (distance % (1000 * 60)) /
                1000
            );

            return {
                days: String(days).padStart(2, "0"),
                hours: String(hours).padStart(2, "0"),
                minutes: String(minutes).padStart(2, "0"),
                seconds: String(seconds).padStart(2, "0")
            };
        }
    },
    async created() {
        this.loadData();
        // Listen for the custom event so it updates without a reload
        window.addEventListener('storage-update', this.loadData);
    },
    async mounted() {
        
        // $('#customCarousel').on('slid.bs.carousel', function () {

        // const total = $('.carousel-item').length;
        //     const current = $('.carousel-item.active').index();

        //     if (current === total - 1) {
        //     setTimeout(() => {
        //         $('#customCarousel').carousel(0);
        //     }, 10);
        //     }

        // });
        await this.currentCohort();
        await this.initializeCountdown();

        // new 
        // setInterval(() => {
        //     this.currentTime += 1000;
        // }, 1000);
        // new

        this.timerInterval = setInterval(() => {
            this.currentTime += 1000;
        }, 1000);
        // this.timerInterval = setInterval(() => {
        //     // console.log("currenttime Mount", this.currentTime)
        //     this.currentTime = Date.now() + this.serverOffset;
        // }, 1000);

        // this.timerInterval = setInterval(() => {
        //     this.currentTime = new Date();
        //     if (this.showCountdown) {
        //         clearInterval(this.timerInterval);
        //     }
        // }, 1000);
        
        if (!this.activeKid) {
            await this.loadData();
        }
        this.loadKidProfile();
    },
    beforeDestroy() {
        // Prevents memory leaks if component destroys
        // clearInterval(this.timerInterval);
        clearInterval(this.timer);
    },
    methods: {
        goBack() {
             this.$router.back();
        },
        async loadData() {
            const savedData = localStorage.getItem('kidDetails');
            if (savedData && savedData !== 'undefined') {
                this.activeKid = JSON.parse(savedData);
                await this.fetchKidsChallenges();
            }
        },



        // new timer starts
        async initializeCountdown() {
            try {
                const clientTime = Date.now();

                // Calculate server/browser difference once
                // console.log("currenttime", this.currentTime)
                this.serverOffset = this.currentTime - clientTime;

                // Set initial value
                this.currentServerTime = this.currentTime;
                // this.currentServerTime =
                //     Date.now() + this.serverOffset;

                // Update every second
                this.timer = setInterval(() => {
                    this.currentServerTime =
                        Date.now() + this.serverOffset;
                }, 1000);
            } catch (error) {
                console.error("Countdown initialization failed:", error);
            }
        },

      
        // New timer ends

        async loadKidProfile() {
            this.loading = true;
            try {
                // 2. Call the imported function directly
                const data = await fetchSuperkidsParentsKids();
                this.mySuperKids = data.data;
                // this.loading = false;
                console.log("Datatata", data)
            } catch (error) {
                console.error("Error:", error);
            } finally {
                this.loading = false;
            }
        },
        async fetchKids() {
            try {
                await Api.getRequest('fetch-parent-kids').then(res => {
                console.log("kids", res);
                }).catch(err => {
                    console.log("err:", err)
                })
            } finally {
                // console.log("closed")
            }
        },
        parseServerDate(dateStr) {
            const clean = dateStr.trim().replace(/\s+/g, " ");

            const parts = clean.split(" ");

            const datePart = parts[0];
            const timePart = parts[1];

            if (!datePart || !timePart) {
                // console.error("Invalid date format:", dateStr);
                return null;
            }

            const [day, month, year] = datePart.split("-");
            // console.log("formated", `${year}-${month}-${day}T${timePart}`)
            return new Date(`${year}-${month}-${day}T${timePart}`);
        },
        async currentCohort() {
            try {
                await Api.getRequest('current-cohort').then(res => {
                    // console.log("Current cohort", res);
                    this.startDate = new Date(res.data.cohort.start_date);
                    this.endDate = new Date(res.data.cohort.end_date);
                    this.currentTime =  this.parseServerDate(res.data.date_time).getTime();
                    // this.currentTime = new Date(res.data.date_time);
                    // this.currentTime = new Date();

                    // console.log("dATA", this.startDate, this.endDate)
                }).catch(err => {
                    console.log("err:", err)
                })
            } finally {
                // console.log("closed")
            }
        },
        async fetchKidsChallenges() {
            // console.log("kidd active", this.activeKid)
            this.loading = true;
            try {
                await Api.getRequest(`fetch-kids-current-current-challenges-by-kid-id/${this.activeKid.id}`).then(res => {
                // console.log("Active Kid", this.activeKid)
                // console.log("kids challenges", res);
                this.loading = false;
                if (res.data.success) {
                    this.slides = res.data.data;
                   const imageLibrary = {
                        1: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772699440/plane1_ebu6ws.svg",
                        2: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772731731/plan3_a6gztq.svg",
                        3: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774529722/plane-bg-5_mpyssp.svg",
                        4: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774529722/plane-bg-8_vahhnx.svg",
                        5: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774529722/plane-bg-7_ktt4rw.svg",
                        6: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774529722/plane-bg-6_tsy3d9.svg",
                        7: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772727881/plan2_gmgzeb.svg",
                        8: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772731804/plan4_oiqemu.svg",
                        9: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1781520942/Challenge_card_big_ee9mod.svg"
                    };

                    this.slides = this.slides.map(item => ({
                        ...item,
                        // It looks for the URL by ID; if not found, it uses a placeholder
                        imageUrl: imageLibrary[item.category_id] || "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772111385/Challenge_card_small_whqefx.svg"
                    }));
                }
                this.$nextTick(() => {
                    // 3. Manually tell Bootstrap to go back to the first slide
                    $('#customCarousel').carousel(0); 
                    
                    // 4. Force a "cycle" refresh if it feels stuck
                    $('#customCarousel').carousel('cycle');
                });
                }).catch(err => {
                    console.log("err:", err)
                    this.loading = false;
                })
            } finally {
                // console.log("closed")
            }
        },
        routeTo(routee) {
            this.$router
            .push({
            path: routee
            })
            .catch(() => {
            // console.log("none")
            });
        }
    }
};
</script>


<style lang="scss" scoped>
.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
}
.name-tag {
    margin-top: 30px;
    margin-bottom: 30px;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;  
        color: #4B4B4F;
        text-align: left;
    }

}
.count-item {
    border: 1px solid #F5F7FA;
    background: #ffffff;
    border-radius: 20px;
    padding: 12px 16px;
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #5D6F7C;
        text-align: left;
        margin-bottom: 15px;
    }
    h2 {
        font-family: Poppins;
        font-weight: 600;
        font-size: 28px;
        color: #1C2B3A;
        line-height: 100%;
        text-align: left;
    }
}

.latest-achievement {
    margin-top: 80px;
    h6 {
        // margin-top: 30px;
        font-family: Lato;
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        color: #5D6F7C;
        text-align: left;
    }
}

.achievement_list {
    margin-top: 20px;
    background: #ffffff;
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        color: #000000;
        text-align: left;
        margin-bottom: 0;
    }
    h4 { 
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #1C2B3A;
        text-align: left;
    }
}

.achievement_item {
    padding: 20px 15px;
    border-bottom: 1px solid #e8e5e5;
}

.carosel-section {
    margin-bottom: 50px !important;
}

.middle-section {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 30px;
    button {
        background-color: #2EBFCA; 
        color: #ffffff;
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        box-shadow: none;
        outline: 0;
        border: 1px solid #ffffff;
        border-radius: 50px;
        white-space: nowrap;
    }
}


//carousel begins
.carousel-indicators li {
  width: 20px;
  height: 20px;
  border-radius: 50px;        /* makes it round */
  background-color: #E6E6E6; /* inactive color */
  opacity: 1;                /* remove Bootstrap fade */
  margin: 0 5px;
}

.carousel-caption {
//   background: rgba(0, 0, 0, 0.5);
  padding: 20px;
  padding-top: 0 !important;
  border-radius: 5px;
  position: static;
  width: 100%;
}
.carousel-indicators .active {
  width: 30px;               /* pill width */
  height: 20px;
  border-radius: 20px;       /* pill shape */
  background-color: #2EBFCA;     /* active color */
}
// * {
//   outline: 1px solid red;
// }
.overlay-content {
  position: absolute;
//   top: 50%;
  top: 45%;
  left: 8%;
//   margin: 0 auto;
//   margin-left: 8%;
  transform: translateY(-50%);
  color: #fff;
  max-width: 450px;
  width: 100%;
  text-align: left;
//   box-sizing: border-box;
  h6 {
    font-family: Nunito;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align: left;
  }
  h3 {
    // margin-top: 20px;
    font-family: Nunito;
    font-weight: 800;
    font-size: 35px;
    line-height: 50px;
    color: #000000;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  p {
    margin-top: 15px;
    font-family: Lato;
    font-weight: 400;
    font-size: 20px;
    color: #5D6F7C;
    line-height: 28px;
    text-align: left;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;   /* number of lines allowed */
    -webkit-box-orient: vertical;
  }
  h4 {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 100%;
    text-align: left;

  }
  button {
    background: #2EBFCA;
    color: #ffffff;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    box-shadow: none;
    outline: 0;
    border: 1px solid #ffffff;
    border-radius: 50px;
    height: 36px;
    width: 136px;
    margin-top: 30px;
  }
}

.small-text {
  font-size: 14px;
  margin-bottom: 10px;
}

.main-title {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 15px;
}

.description {
  font-size: 16px;
}

.carousel-item {
    img {
        border-radius: 20px;
        height: 400px;
        object-fit: cover;
    }
}

.carousel-control-next, .carousel-control-prev {
    width: 8%;
}
.carousel-indicators {
  bottom: 20px;
  position: static; 
}



@media (max-width: 768px) {
  .carousel-item img {
    height: auto;
    min-height: 400px;
    object-fit: cover;
  }
  .carousel-indicators {
    position: static;   /* removes absolute positioning */
    margin-top: 15px;   /* space below image */
  }
  .overlay-content {
    max-width: 100%;
    width: 100%;
    top: 50%;
    padding: 0 15px;
    h3 {
        margin-top: 7px;
        font-size: 26px;
        line-height: 38px;
    }
    p {
        margin-top: 0;
    }
  }
}
//carousel ends

@media only screen and (max-width: 599px) {
    .count-item {
        padding: 12px 15px;
        h5 {
            font-size: 12px;
        }
        h2 {
            font-size: 18px;
        }
    }
    .overlay-content {
        max-width: 100%;
        width: 100%;
        padding: 0 15px;
        margin-left: 0;
        left: 0;
    }
}



// Countdown section starts here
.countdown-container, .expired-container {
  text-align: center;
//   background: #1e293b;
  background: #062b68;
  padding: 1.5rem;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
  border: 1px solid #334155;
  width: 100%;
  margin-top: 100px;
//   max-width: 550px; /* Limits size on desktop */
    
}

/* Typography using fluid values */
.title {
  margin-top: 0;
  font-weight: 500;
  letter-spacing: 0.05em;
  color: #94a3b8;
  font-family: Lato;
  font-size: clamp(1.2rem, 4vw, 1.75rem); /* Dynamically scales text */
}

.title.success {
  color: #34d399;
}

.description {
  color: #64748b;
  font-size: clamp(0.9rem, 3vw, 1.1rem);
}

/* Flexbox Grid - Handles Wrap Automatically */
.timer {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  margin-top: 1.5rem;
  flex-wrap: wrap; /* Allows cards to wrap into 2x2 grid if space runs out */
}

/* Time Blocks - Fluid width using percentage bounds */
.time-block {
  display: flex;
  flex-direction: column;
  background: #0f172a;
  padding: 0.75rem;
  flex: 1 1 calc(25% - 0.75rem); /* Fits 4 in a row on standard screens */
  min-width: 70px; /* Minimum fallback size */
  border-radius: 12px;
  border: 1px solid #475569;
}

.number {
  font-size: clamp(1.75rem, 6vw, 2.75rem); /* Giant on desktop, compact on mobile */
  font-weight: 700;
  color: #38bdf8;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
}

.label {
  font-size: clamp(0.65rem, 2vw, 0.8rem);
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.1em;
  margin-top: 0.25rem;
}

/* Specific Media Query for ultra-narrow screens (under 360px) */
@media (max-width: 360px) {
  .timer {
    gap: 0.5rem;
  }
  .time-block {
    flex: 1 1 calc(50% - 0.5rem); /* Drops perfectly into a clean 2x2 square grid */
    padding: 0.5rem;
  }
}
// Countdown sections end here
</style>